var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "../PrimitiveComponent";
import { defaults, heapDefaults } from "../../style";
import { deepAwaitMixin } from "../../mixins/DeepAwaitMixin";
let OtherComponent = class OtherComponent extends deepAwaitMixin(LitElement) {
    get typeName() {
        return this.el[0];
    }
    get value() {
        return this.el[1];
    }
    render() {
        return html `
            <label>${this.typeName}</label>
            <table>
                <tr><td>${this.value}</td></tr>
            </table>
        `;
    }
};
OtherComponent.styles = [defaults, heapDefaults];
__decorate([
    property({ type: Array })
], OtherComponent.prototype, "el", void 0);
OtherComponent = __decorate([
    customElement('tc-other')
], OtherComponent);
export { OtherComponent };
//# sourceMappingURL=OtherComponent.js.map